export default class MachineBase {
  // #region MAIN
  name = 'base';
  // #endregion

  // #region STATE MACHINE INTERFACE
  onInit(obj: any) {}

  onRelease(obj: any) {}

  onSuspend(obj: any) {}

  onWakeup(obj: any) {}

  validateStartup(obj: any): boolean {
    return true;
  }
  // #endregion

  // #region GIZMO EVENTS
  onGizmoRotate(v: Array<number>) {}

  onGizmoTranslate(v: Array<number>) {}

  onGizmoDragStart() {}

  onGizmoDragEnd() {}

  onGizmoModeChange(mode: string) {}
  // #endregion

  // #region HISTORY EVENTS
  onUndoRedo() {}
  // #endregion

  // #region POINTER / MOUSE EVENTS
  //   onPointerDown(x: number, y: number, e: PointerEvent, obj: any): boolean {
  //     console.log('onPointerDown', x, y, this.name);
  //     return false;
  //   }

  //   onPointerMove(x: number, y: number, e: PointerEvent, obj: any) {
  //     console.log('onPointerMove', x, y, this.name);
  //   }

  //   onPointerUp(e: PointerEvent, obj: any) {
  //     console.log('onPointerUp', this.name);
  //   }
  //   onPointerCancel(e: PointerEvent, obj: any) {
  //     console.log('onPointerCancel', this.name);
  //   }

  //   onDblClick(e: MouseEvent, obj: any) {
  //     console.log('onDblClick', this.name);
  //   }

  //   onContextMenu(e: MouseEvent, obj: any) {
  //     console.log('onContextMenu', this.name);
  //   }
  // #endregion

  // #region KEYBOARD EVENTS
  //   onKeyDown(e: KeyboardEvent, obj: any) {
  //     console.log('onKeyDown', e.key, this.name);
  //   }

  //   onKeyUp(e: KeyboardEvent, obj: any) {
  //     console.log('onKeyUp', e.key, this.name);
  //   }
  // #endregion
}
